import {SmallDesc} from "@ui/descriptions/SmallDesc";

import styles from "./styles.module.scss";

export const RootCheckbox = (props) => {
  const {checked, onChange, label, disabled, fontSize, tabIndex} = props;

  const handleKeyDown = (e) => {
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      if (!disabled) {
        onChange(!checked);
      }
    }
  };

  return (
    <label
      className={styles.rootCheckbox}
      style={{pointerEvents: `${disabled ? "none" : "all"}`}}
      tabIndex={tabIndex ? tabIndex : undefined}
      onKeyDown={tabIndex ? handleKeyDown : undefined}
      role={"checkbox"}
      aria-checked={checked}
    >
      <input
        type={"checkbox"}
        checked={disabled ? false : checked}
        onChange={disabled ? undefined : onChange}
        aria-label={label}
        disabled={disabled}
      />

      <i className={styles.mark} />

      {label && (
        <SmallDesc>
          <span
            style={
              fontSize ? {fontSize: `${fontSize}rem`} : {fontSize: `14rem`}
            }
          >
            {label}
          </span>
        </SmallDesc>
      )}
    </label>
  );
};
